import { downloadTrack, DownloadTrackAction } from '../../redux/actions/download';
import { EventCategory, EventDefinition, EventsMap, ProductEvent } from '../types';

const downloadTrackEvent: EventDefinition<DownloadTrackAction> = ({ payload }) => {
  const track = payload.track;
  let label: string = track && track.title ? track.title : '';
  if (track.artist) {
    label = `${label} by ${track.artist.name}`;
  }
  return {
    category: EventCategory.Download,
    event: ProductEvent.Download,
    action: ProductEvent.Download,
    label,
  };
};

export const downloadsEventsMap: EventsMap = {
  [downloadTrack.type]: downloadTrackEvent,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/downloads.ts